import { trackEvent } from '@99designs/common/utils/platform';
import Cookies from 'cookies-js';

export default class LikeableDesign {
    designId: string;
    likeButton: Element;
    likeCountElement: Element;
    likeAttr: string;
    cookieKey: string;

    constructor(designId: string, likeButton: Element, likeCountElement: Element) {
        this.designId = designId;
        this.likeButton = likeButton;
        this.likeCountElement = likeCountElement;
        this.likeAttr = 'data-liked';
        this.cookieKey = 'liked_designs';

        this.likeButton.addEventListener('click', () => {
            this.toggleLike();
        });
    }

    initialise() {
        if (this.hasDesignBeenLiked()) {
            this.likeDesign();
        }
    }

    hasDesignBeenLiked() {
        const cookie = Cookies.get(this.cookieKey);

        return cookie && cookie.indexOf(`${this.designId}`) !== -1;
    }

    toggleLike() {
        if (this.likeButton.hasAttribute(this.likeAttr)) {
            this.unlikeDesign();
            this.removeDesignFromCookie();
            this.trackClickEvent(false);
        } else {
            this.likeDesign();
            this.addDesignToCookie();
            this.trackClickEvent(true);
        }
    }

    likeDesign() {
        this.likeButton.setAttribute(this.likeAttr, '');
        this.likeCountElement.innerHTML = (
            parseInt(this.likeCountElement.innerHTML) + 1
        ).toString();
    }

    unlikeDesign() {
        this.likeButton.removeAttribute(this.likeAttr);
        this.likeCountElement.innerHTML = (
            parseInt(this.likeCountElement.innerHTML) - 1
        ).toString();
    }

    removeDesignFromCookie() {
        const cookie = Cookies.get(this.cookieKey);
        const updatedDesignIds = cookie.replace(`${this.designId},`, '');

        if (updatedDesignIds) {
            Cookies.set(this.cookieKey, updatedDesignIds);
        } else {
            Cookies.expire(this.cookieKey);
        }
    }

    addDesignToCookie() {
        const cookie = Cookies.get(this.cookieKey);

        if (cookie) {
            Cookies.set(this.cookieKey, cookie.concat(`${this.designId},`));
        } else {
            Cookies.set(this.cookieKey, `${this.designId},`);
        }
    }

    trackClickEvent(liked: boolean) {
        trackEvent('Clicked Like Button On Inspiration Page', {
            liked: liked,
        });
    }

    static create(design: HTMLElement) {
        const designId = design.getAttribute('data-likeable-design');
        const likeButton = design.querySelector('[data-likeable-design-like-button]');
        const likeCountElement = design.querySelector('[data-likeable-design-like-count]');

        if (!designId || !likeButton || !likeCountElement) return;

        const likeableDesign = new LikeableDesign(designId, likeButton, likeCountElement);

        likeableDesign.initialise();
    }
}
